import { render, staticRenderFns } from "./CarImageRotator.vue?vue&type=template&id=f1662150&scoped=true&"
import script from "./CarImageRotator.vue?vue&type=script&lang=js&"
export * from "./CarImageRotator.vue?vue&type=script&lang=js&"
import style0 from "./CarImageRotator.vue?vue&type=style&index=0&id=f1662150&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1662150",
  null
  
)

export default component.exports